import React, { useState, useEffect } from "react";
import {
  Chart,
  Settings,
  LineSeries,
  Axis,
  Position,
  Tooltip,
  DARK_THEME,
  LIGHT_THEME,
  ScaleType,
  timeFormatter,
} from "@elastic/charts";
import Loader from "../../../shared/Loader";
import { useTheme } from "../../../../context/ThemeContext";
import StatsService from "../../../../services/v2/inbound/stats-service";

const TimelineDistribution = ({ filters, timeInterval }) => {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { isDarkMode } = useTheme();

  useEffect(() => {
    setLoading(true);
    setError(false);
    const payload = { ...filters, timeInterval };
    StatsService.timelineDistribution(payload)
      .then(({ data: { data } }) => {
        // Transformar los datos para adaptarlos a @elastic/charts
        const transformedData = [];
        data.forEach((callResultData) => {
          callResultData.timeline.forEach((entry) => {
            transformedData.push({
              g: callResultData.callResult, // Agrupación por tipo de llamada
              x: entry.time, // Eje X (Tiempo)
              y: entry.count, // Eje Y (Conteo de llamadas)
            });
          });
        });
        setData(transformedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(true);
        setLoading(false);
      });
  }, [filters, timeInterval]);

  if (isLoading)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (error)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <div className="text-red-500 text-sm font-semibold text-center">
          Some error occurred loading data
        </div>
      </div>
    );

  const formatter = (time) => {
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(time));
  };
  return (
    <div className={`w-full h-full ${isDarkMode ? "dark-legend" : ""}`}>
      <Chart size="100%">
        <Settings
          showLegend={true}
          legendPosition="left"
          baseTheme={isDarkMode ? DARK_THEME : LIGHT_THEME}
          theme={{
            background: {
              color: isDarkMode ? "#1A202C" : "#ffffff",
            },
            axes: {
              tickLine: {
                stroke: isDarkMode ? "#ffffff" : "#000000",
              },
              tickLabel: {
                fill: isDarkMode ? "#ffffff" : "#000000",
              },
            },
          }}
        />
        <Tooltip
          style={{
            backgroundColor: isDarkMode ? "#1f2937" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#000000",
            border: `1px solid ${isDarkMode ? "#4B5563" : "#E5E7EB"}`,
          }}
        />
        <LineSeries
          id="timeline-distribution"
          xScaleType={ScaleType.Time}
          yScaleType={ScaleType.Linear}
          xAccessor="x" // Eje X
          yAccessors={["y"]} // Altura de las líneas
          splitSeriesAccessors={["g"]} // Divide las series por resultado de llamada
          data={data}
        />
        <Axis
          id="bottom-axis"
          position={Position.Bottom}
          showOverlappingTicks
          tickFormat={formatter} // Formato de fecha dinámico
          tickLabelStyle={{
            fill: isDarkMode ? "#ffffff" : "#000000", // Etiquetas del eje X
          }}
        />
        <Axis
          id="left-axis"
          position={Position.Left}
          tickFormat={(d) => Number(d).toFixed(0)} // Formato de conteo
          tickLabelStyle={{
            fill: isDarkMode ? "#ffffff" : "#000000", // Etiquetas del eje Y
          }}
        />
      </Chart>
    </div>
  );
};

export default TimelineDistribution;
